export const locale = {
  lang: 'sv-SE',
  data: {
    INTRODUCE:
      'Xbaht AB är ett auktoriserat betalningsinstitut, reglerat av Finansinspektionen att utföra penningöverföring enligt betaltjänstlagen (2010:751)',
    COMPANY: {
      TITLE: 'Kontakta oss',
      CONTACT_US: 'Xbaht AB',
      ADDRESS: 'Isbergs Gata 8C, 211 19 Malmö - Sweden',
      TELEPHONE: 'Tel. +46 1 0750 0750',
      EMAIL: 'hello@xbaht.com',
    },
    USEFULL_LINKS: {
      TITLE: 'Villkor',
      TERMS_AND_CONDITIONS: 'Allmänna villkor',
      PRIVACY_POLICY: 'Integritetspolicy',
      COMPLAINT: 'Klagomål',
      WHISTLEBLOWER: 'Whistleblower',
    },
    POWERED_BY: {
      TITLE: 'Powered By',
    },
    COPYRIGHT:
      'Copyright {{year}} © Xbaht AB | Company Registration No. 559068-4303 | FSA No. 45607',
  },
};
